import { render, staticRenderFns } from "./private-blog-details.html?vue&type=template&id=1a80d072&scoped=true&external"
import script from "./private-blog-details.js?vue&type=script&lang=js&external"
export * from "./private-blog-details.js?vue&type=script&lang=js&external"
import style0 from "./private-blog-details.scss?vue&type=style&index=0&id=1a80d072&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a80d072",
  null
  
)

export default component.exports